module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'trips',
        showHead: true,
        showIDs: true,
        showTDVerticalTop: true,
        isSortable: true,
        preventSortOfField: {
            statusFlagsSummary: true,
        },
        rowActionsInline: true,
        rowActionsProperties: {
            colWidth: '120px',
        },
        rowActions: {
            edit: true,
            customs: [
                {
                    buttonType: 'delete',
                    neutral: true,
                },
                {
                    buttonType: 'showDuplicateOptions',
                },
            ]
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bosch_trips': true,
            'resourceChanged.bosch_tripDriverVessels': true,
            'resourceChanged.bosch_drivers': true,
        },
    },

    model: {
        resourceFilters: {
            order: [{
                fieldCode: 'tripID',
                direction: 'desc'
            }]
        }
    },

    methods: {
        onBuild(){
            this.config.customHeadActionsFormMapping = {
                buttons: [
                    { buttonType: 'showInsert', context: this.config.buttonContext, positive: true }
                ]
            }
        },

        onSubmitDone(callerComponent, entityID, entityData, insertPerformed){
            switch(((callerComponent || {}).config || {}).entityContext){
                case 'trips':
                    if(insertPerformed && entityID && entityData){
                        this.showEdit(entityID, entityData)
                    }
            }
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers 	= this.config.heartbeatRefreshOn || {}
            const key 			= message.heartbeatKey

            if(refreshers[key] && (
                (key === 'reconnect') ||
                (key === 'resourceChanged.bosch_trips') ||
                (key === 'resourceChanged.bosch_tripDriverVessels') ||
                (key === 'resourceChanged.bosch_drivers')
            )){
                this.delayedLastOf('refreshByHeartbeat', () => this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes }), 50)
            }
        },
    },
}